import { TimeSeriesEntityTypeConstants } from '@/constants/TimeSeriesEntityTypeConstants';
import type { IItemUnderAnalysis } from '@/types/IItemUnderAnalysis';
import { isPortfolioTreeStrategy } from '@/types/IPortfolioTree';

/** Strategy factsheet or portfolio-tree strategy whose entity type is benchmark. */
export function isBenchmarkStrategyItemUnderAnalysis(itemUnderAnalysis: IItemUnderAnalysis | null): boolean {
  if (!itemUnderAnalysis) return false;

  if (
    ('strategyApiConfig' in itemUnderAnalysis && 'strategy' in itemUnderAnalysis) ||
    isPortfolioTreeStrategy(itemUnderAnalysis)
  ) {
    return itemUnderAnalysis.strategy?.type === TimeSeriesEntityTypeConstants.BENCHMARK;
  }

  return false;
}
